import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Container } from "react-bootstrap";
import { rSetShowFab } from "../../redux/reducers/GlobalVariables";
import CardHeadMenu from "../../Components/Card/CardHeadMenu/CardHeadMenu";
import configServ from "../../services/config";
import EmployeeCard from "./EmployeeCard";
import EmployeeTable from "./EmployeeTable";
import Swal from "sweetalert2";
import toast from "react-hot-toast";
import { Dialog, DialogContent } from "@mui/material";
import CameraCard from "./CameraCard";
import MultiPageDialog from "./MultiPageDialog";

const EmployeePage = () => {
  const { company_id, user_id, is_super, is_admin, permissions } = useSelector(
    (state) => state.GlobalVariables
  );
  const dispatch = useDispatch();

  const [isCreate, setIsCreate] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isChanged, setIsChanged] = useState(false);
  const [editData, setEditData] = useState({});
  const [employeeList, setEmployeeList] = useState([]);
  const [loader, setLoader] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [total, setTotal] = useState(0);
  const [designationList, setDesignationList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);

  const scrollToTop = () => window.scrollTo({ top: 0 });

  useEffect(() => { scrollToTop(); }, []);

  const handlePopup = () => {
    if (isCreate) clear();
    dispatch(rSetShowFab(isCreate));
    setIsCreate((p) => !p);
    setIsEdit(false);
  };

  const handleEdit = (row) => {
    dispatch(rSetShowFab(isCreate));
    setEditData(row);
    setIsEdit(true);
    setIsCreate(true);
    scrollToTop();
  };

  const clear = () => {
    setEditData({});
    setIsEdit(false);
  };

  const fetchEmployees = async () => {
    setLoader(true);
    try {
      const res = await configServ.getEmployees({
        company_id,
        user_id,
        is_admin: Boolean(is_super || is_admin),
        page: page + 1,
        per_page: rowsPerPage,
      });
      if (res?.status) {
        setEmployeeList(res.data);
        setTotal(res.pagination.total);
      } else {
        setEmployeeList([]);
        setTotal(0);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => { fetchEmployees(); }, [page, rowsPerPage, isChanged]);

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Deactivate Employee?",
      text: "The employee will be marked inactive. This can be reversed by editing.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, deactivate",
    });
    if (!result.isConfirmed) return;

    try {
      const res = await configServ.deleteEmployee(id);
      if (res?.status) {
        toast.success("Employee deactivated");
        setIsChanged((p) => !p);
      } else {
        toast.error(res?.message || "Failed to deactivate");
      }
    } catch (e) {
      toast.error("Something went wrong");
      console.error(e);
    }
  };

  const [openCamera, setOpenCamera] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [userId, setUserId] = useState(null);

  const [dialogOpen, setDialogOpen] = useState(false);
  // OPEN CAMERA
  const handleOpenCamera = (emp) => {
    console.log("Opening camera for employee:", emp);
    setSelectedId(emp.id);
    setUserId(emp.customer_id);
    setOpenCamera(true);
  };

  const handleOpenMoreDetails = (emp) => {
    setSelectedId(emp.id);
    setUserId(emp.customer_id);
    setDialogOpen(true);
  };

  const fetchDesignations = async () => {
    try {
      const res = await configServ.getAllDesignations(company_id);
      if (res?.status) setDesignationList(res.data);
    } catch (e) {
      console.error(e);
    }
  };

  const fetchDepartments = async () => {
    try {
      const res = await configServ.getAllDepartments(company_id);
      if (res?.status) setDepartmentList(res.data);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (isCreate || isEdit) {
      fetchDesignations();
      fetchDepartments();
    }
  }, [isCreate, isEdit]);




  return (
    <Container width="100%" maxWidth="xl" sx={{ mt: 2, mb: 4 }}>
      <Dialog
        open={openCamera}
        onClose={() => setOpenCamera(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogContent sx={{ p: 0 }}>
          <CameraCard
            id={selectedId}
            user_id={userId}
            onClose={() => setOpenCamera(false)}
          />
        </DialogContent>
      </Dialog>
      <CardHeadMenu
        prefix="Na"
        suffix="Na"
        title="EMPLOYEES"
        handlePopup={handlePopup}
        isEdit={isEdit}
        create={isCreate}
        showCreate={Boolean(is_super || is_admin || permissions?.includes(83))}
      />

      <MultiPageDialog
        open={dialogOpen}
        handleClose={() => setDialogOpen(false)}
        id={selectedId}
        user_id={userId}
      />

      {isCreate && (
        <EmployeeCard
          isEdit={isEdit}
          setIsEdit={setIsEdit}
          editData={editData}
          setEditData={setEditData}
          isCreate={isCreate}
          setIsCreate={setIsCreate}
          setIsChanged={setIsChanged}
          clear={clear}
          designationList={designationList}
          departmentList={departmentList}

        />
      )}

      <EmployeeTable
        employeeList={employeeList}
        loader={loader}
        page={page}
        rowsPerPage={rowsPerPage}
        total={total}
        setPage={setPage}
        setRowsPerPage={setRowsPerPage}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
        handleOpenCamera={handleOpenCamera}
        handleOpenMoreDetails={handleOpenMoreDetails}
      />
    </Container>
  );
};

export default EmployeePage;
